import { WireCreditor } from '@treasury/domain/wires';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './creditor-data-readonly';

export const tagName = 'creditor-review-step';
@customElement(tagName)
export class CreditorReviewStep extends TmBaseComponent {
    @property({ type: Object, attribute: false })
    private creditor?: WireCreditor;

    @state()
    private workflow?: string;

    protected render() {
        const buttonConfig = [];
        switch (this.workflow) {
            case 'creditor-create':
                buttonConfig.push({
                    text: 'Create',
                    disabled: false,
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('create', { detail: this.creditor }));
                    },
                });
                break;
            case 'creditor-edit':
                buttonConfig.push({
                    text: 'Confirm',
                    disabled: false,
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('edit', { detail: this.creditor }));
                    },
                });
                break;
            case 'wire':
            default:
                buttonConfig.push(
                    {
                        text: 'Continue',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(
                                new CustomEvent('continue', { detail: this.creditor })
                            );
                        },
                    },
                    {
                        text: 'Continue and save creditor',
                        onClick: () => {
                            this.dispatchEvent(
                                new CustomEvent('continue-save', { detail: this.creditor })
                            );
                        },
                    }
                );
        }
        return html`<creditor-data-readonly .creditor=${this.creditor}></creditor-data-readonly>
            <tm-footer .buttonConfig=${buttonConfig}></tm-footer> `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CreditorReviewStep;
    }
}
